import { useEffect } from 'react';
import {
  XaiSmallTile,
  XaiInnerTilesWrapper,
  TileHeaderText,
  TileBodyText,
  XaiSlideOverTextWrapper,
  XaiContentWrapper,
  XaiLikelyEmptyStateText,
  XAILinkcaption,
  StyledNewTabLink,
} from '../Styled';
import {
  TEST_IDS,
  XAI_FEATURES_HEADER_TEXT,
  XAI_LIKELY_EMPTY_STATE_TEXT,
  PREDICTIVE_STRENGTH,
  XAI_DONUT_CHART_CARD_HEADER_TEXT,
} from '../../constants';
import { PredictiveStrengthMeterIcon } from '../PredictiveStrengthMeterIcon';
import { Direction } from '../../types';
import { XAILikelyTile } from './XAILikelyTile';
import { XAILikelyTileFeatureList } from './XAILikelyTileFeatureList';
import { XaiSlideOverDonutChartContainer } from './XaiSlideOverDonutChartContainer';
import { XaiSlideOverContentTypes } from './types';

const DIRECTIONALITY_THRESHOLD = 0.03;

export const XaiSlideOverContent = ({ features, predictiveStrength }: XaiSlideOverContentTypes) => {
  const topThreeFeaturesIncreaseDirectionality = features
    .filter((feature) => {
      return (
        feature.direction === Direction.INCREASE && feature.strength >= DIRECTIONALITY_THRESHOLD
      );
    })
    .slice(0, 3);
  const topThreeFeaturesDecreaseDirectionality = features
    .filter((feature) => {
      return (
        feature.direction === Direction.DECREASE && feature.strength >= DIRECTIONALITY_THRESHOLD
      );
    })
    .slice(0, 3);

  useEffect(() => {
    setTimeout(() => {
      // width exceeds container width on first load in safari. disptach event will force resize
      window.dispatchEvent(new Event('resize'));
    }, 100);
  });

  return (
    <XaiContentWrapper data-test={`${TEST_IDS.XAISlideOverContent}`}>
      <XaiInnerTilesWrapper>
        <XaiSmallTile data-test={`${TEST_IDS.XAITilePredictiveStrength}`}>
          <TileHeaderText>{PREDICTIVE_STRENGTH}</TileHeaderText>
          <TileBodyText>
            {`${predictiveStrength}`}
            <PredictiveStrengthMeterIcon
              strength={predictiveStrength}
            ></PredictiveStrengthMeterIcon>
          </TileBodyText>
        </XaiSmallTile>
        <XaiSmallTile data-test={`${TEST_IDS.XAITileFeatureCount}`}>
          <TileHeaderText>{XAI_DONUT_CHART_CARD_HEADER_TEXT}</TileHeaderText>
          <TileBodyText>{features?.length}</TileBodyText>
        </XaiSmallTile>
      </XaiInnerTilesWrapper>
      {features.length > 0 && <XaiSlideOverDonutChartContainer features={features} />}
      <XaiSlideOverTextWrapper>{XAI_FEATURES_HEADER_TEXT}</XaiSlideOverTextWrapper>
      <XAILikelyTile directionality={Direction.INCREASE}>
        {topThreeFeaturesIncreaseDirectionality.length ? (
          <XAILikelyTileFeatureList features={topThreeFeaturesIncreaseDirectionality} />
        ) : (
          <XaiLikelyEmptyStateText>{XAI_LIKELY_EMPTY_STATE_TEXT}</XaiLikelyEmptyStateText>
        )}
      </XAILikelyTile>
      <XAILikelyTile directionality={Direction.DECREASE}>
        {topThreeFeaturesDecreaseDirectionality.length ? (
          <XAILikelyTileFeatureList features={topThreeFeaturesDecreaseDirectionality} />
        ) : (
          <XaiLikelyEmptyStateText data-test={`${TEST_IDS.XAILikelyEmptyStateText}`}>
            {XAI_LIKELY_EMPTY_STATE_TEXT}
          </XaiLikelyEmptyStateText>
        )}
      </XAILikelyTile>
      <XAILinkcaption>
        Learn more about Predictive Goals.{' '}
        <StyledNewTabLink href="https://support.iterable.com/hc/en-us/articles/5000143065492-Evaluating-Your-Prediction#review-explainable-ai-prediction-insights">
          See documentation
        </StyledNewTabLink>
      </XAILinkcaption>
    </XaiContentWrapper>
  );
};
